export default "__VITE_ASSET__DUlvZ35Q__"